module.exports = __webpack_public_path__ + "media/svg/fj-411fbac4.svg";